import * as React from "react";
import { connect } from "react-redux";
import * as Actions from "../../../../redux/actions";
import { AppState } from "../../../../redux";
import { FetchStoryItemPayload, FetchStoryItemAction } from "../../../../redux/cache/types";
import { Story, Entity, GRAPHQL_TYPE_ENTITY, Person } from "@radivision/graphql";
import { PitchVideoPanel } from "./pitch-video-panel";
import { InvestmentNotificationForm } from "./notification-form";
import { ApprovalStatus } from "./approval-status";
import { FundraisingStatus } from "./fundraising-status";
import { AddPitchButton } from "./add-pitch-button";
import isEmpty from "lodash.isempty";
import { Opportunities } from "./opportunities";
import { MissingLongVideo } from "./missing-long-video";
import { CreatePitchModal } from "../../../modals/create-pitch";
import { isOwner } from "../../../../utilities/is-owner";
import { MarketplacePanel } from "../marketplace";
import Description from "./description";

interface ComponentProps {
  entity: Entity;
}

interface MapDispatchProps {
  fetchStoryItem: (payload: FetchStoryItemPayload) => FetchStoryItemAction;
}

interface MapStateProps {
  user: Person | null;
  item: Story;
  isFetching: boolean;
}

export type Props = ComponentProps & MapDispatchProps & MapStateProps;

class Investment extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
    this.fetchItem = this.fetchItem.bind(this);
  }
  componentDidUpdate() {
    this.fetchItem();
  }

  fetchItem() {
    const { item, isFetching, entity, fetchStoryItem } = this.props;
    const id = entity?.pitchOriginalMedia?.id;
    if (id && !item && !isFetching) {
      fetchStoryItem({ id });
    }
  }
  render() {
    const { item, entity, user } = this.props;
    const owner = isOwner(entity, user);
    if (!entity || entity.__typename !== GRAPHQL_TYPE_ENTITY) {
      return null;
    }
    // RESTORE
    const enableEdit = true;
    return (
      <div className="tab-pane fade" id="Opportunities">
        {owner && <Description />}
        {owner && <ApprovalStatus entity={entity} />}
        {owner && <AddPitchButtonContainer entity={entity} />}
        <InvestmentNotificationForm entity={entity} item={item} />
        {owner && <FundraisingStatus entity={entity} item={item} />}
        {enableEdit && owner && <MissingLongVideo entity={entity} item={item} />}
        <PitchVideoPanel entity={entity} item={item} />
        <MarketplacePanel entity={entity} />
        <Opportunities entity={entity} owner={owner} />
        {owner && <CreatePitchModal />}
      </div>
    );
  }
}

export const AddPitchButtonContainer = ({ entity }) => {
  const hasPitchVideo = !isEmpty(entity?.pitchOriginalMedia?.id);
  if (hasPitchVideo) {
    return null;
  }
  return (
    <div className="my-media-tab">
      <div className="add-buttons">
        <AddPitchButton entity={entity} />
      </div>
    </div>
  );
};

const mapState = (state: AppState, props: ComponentProps) => ({
  user: state.account.user,
  item: state.cache.store && state.cache.store[props.entity?.pitchOriginalMedia?.id],
  isFetching: props.entity ? state.cache.inProgress[props.entity?.pitchOriginalMedia?.id] : false,
});

const mapDispatch = {
  fetchStoryItem: Actions.fetchStoryItem,
};

export const InvestmentPanel = connect(mapState, mapDispatch)(Investment);
